import React, { useEffect } from "react";

import AuthLayout from "components/layout/AuthLayout";
import RegisterForm from "features/auth/RegisterForm";

export default function Register() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <AuthLayout
      title="Create your free account"
      subtitle="Jom belajar! Free classes, no card needed."
    >
      <RegisterForm />
    </AuthLayout>
  );
}
